module.exports = __webpack_public_path__ + "static/media/box-lunch.af537e08.png";